export default __webpack_public_path__ + "static/media/timmy kim.f656a927.jpg";